/**
=========================================================
* Argon Dashboard 2 MUI - v3.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-material-ui
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect } from "react";

// react-router-dom components
import { useLocation } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// Argon Dashboard 2 MUI components
import ArgonBox from "components/ArgonBox";

// Argon Dashboard 2 MUI context
import { useArgonController, setLayout } from "context";

function PageLayout({ background, children }) {
    const [controller, dispatch] = useArgonController();
    const { darkMode } = controller;

    const { pathname } = useLocation();

    useEffect(() => {
        setLayout(dispatch, "page");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname]);

    return (
        <ArgonBox
            // width="100vw"
            width="100%"
            height="100%"
            // minHeight="100vh"
            bgColor={darkMode ? "transparent" : background}
            sx={{ overflowX: "hidden" }}
        >
            {children}
        </ArgonBox>
    );
}

// Setting default values for the props for PageLayout
PageLayout.defaultProps = {
    background: "default",
};

// Typechecking props for the PageLayout
PageLayout.propTypes = {
    background: PropTypes.oneOf(["white", "light", "default"]),
    children: PropTypes.node.isRequired,
};

export default PageLayout;
